import feather from "feather-icons";
import VueFeather from "vue-feather";
const listIcon = {} as any;
Object.keys(feather.icons).forEach((icon) => {
  listIcon[icon] = {
    component: VueFeather,
    props: {
      type: icon,
    },
  };
});
export default listIcon;
